import axios from "axios";
//Base da URL: https://api.themoviedb.org/3/
//URL DA API: /movie/now_playing?api_key=fccec1590dfa89943e5b86b92c6e3d0c&language=pt-BR

const api = axios.create({
    baseURL: 'https://api.themoviedb.org/3/',
})

export default api;